module.exports = __webpack_public_path__ + "img/store_IG_brown.ef48336a.svg";